/* oxlint-disable no-inner-declarations */
import * as rq from '@tanstack/react-query';

import { useDexFetchClient } from '@/api/looker/utils/use-dex-fetch-client';
import type { BatteryLevel } from '@/data-explorer-v2/entities/battery-level';
import { useCurrentAsset } from '@/hooks/use-current-asset';
import { useMe } from '@/hooks/use-me';

export namespace GetLevels {
  export const key = (accureId: string) => [
    'data-explorer',
    'get-levels',
    accureId,
  ];

  export type QueryParams = {
    retry?: number | boolean;
  };

  export type Output = {
    battery?: Record<BatteryLevel, string>;
    pcs?: Record<BatteryLevel, string>;
  };

  export type FetchResult = Record<string, Output>;

  export function useQuery({ retry }: QueryParams = {}) {
    const fetchClient = useDexFetchClient();
    const me = useMe();
    const { accureId } = useCurrentAsset();

    // wait for asset to be resolved
    if (!accureId || !me.tenant) {
      return rq.useQuery({
        queryKey: ['data-explorer', 'get-levels', 'pending'],
        queryFn: () => Promise.resolve({} as Output),
        enabled: false,
      });
    }
    return rq.useQuery({
      retry,
      queryKey: key(accureId),
      async queryFn({ signal }) {
        const data = await fetchClient<FetchResult>({
          path: `/v2/levels/${me.tenant}/${accureId ?? ''}`,
          signal,
        });

        const output: Output = data[me.tenant];

        // TODO: remove and just don't return from the API
        // filter out system level for both battery and pcs
        if (output.battery) {
          delete (output.battery as Record<string, string>)['system'];
        }
        if (output.pcs) {
          delete (output.pcs as Record<string, string>)['system'];
        }

        return output;
      },
    });
  }
}
